module.exports = __webpack_public_path__ + "static/img/footer_img2.be2eb20e.png";